import React, { useEffect, useRef, useState } from 'react';

const formatTime = minutes => {
  const dayMinutes = ((Math.round(minutes) % 1440) + 1440) % 1440;
  return `${String(Math.floor(dayMinutes / 60)).padStart(2, '0')}:${String(dayMinutes % 60).padStart(2, '0')}`;
};

export default function WellwiredClock({ minutes }) {
  const [displayed, setDisplayed] = useState(minutes);
  const current = useRef(minutes);
  const clockRef = useRef(null);

  useEffect(() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const start = current.current;
    const duration = parseFloat(getComputedStyle(clockRef.current).getPropertyValue('--ww-duration')) || 1150;
    let frame = 0;
    let started;
    const display = value => {
      current.current = value;
      setDisplayed(value);
    };
    const finish = () => {
      cancelAnimationFrame(frame);
      display(minutes);
    };
    const step = now => {
      if (started === undefined) started = now;
      const progress = Math.min(1, (now - started) / duration);
      const eased = progress * progress * (3 - 2 * progress);
      // Two-minute steps stay readable; absolute minutes carry night past midnight.
      display(progress === 1 ? minutes : Math.round((start + (minutes - start) * eased) / 2) * 2);
      if (progress < 1) frame = requestAnimationFrame(step);
    };
    const preferenceChanged = () => { if (reduced.matches) finish(); };
    if (reduced.matches || start === minutes) finish();
    else frame = requestAnimationFrame(step);
    reduced.addEventListener('change', preferenceChanged);
    return () => {
      cancelAnimationFrame(frame);
      reduced.removeEventListener('change', preferenceChanged);
    };
  }, [minutes]);

  return (
    <span ref={clockRef} className="ww-time ww-day-clock" role="timer" aria-live="off" aria-label={`Time of day: ${formatTime(minutes)}`}>
      <span aria-hidden="true">{formatTime(displayed)}</span>
    </span>
  );
}
